// avstemming-payroll-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'ave.c.gross': 'Salario bruto',
  'ave.c.net': 'Salario neto',
  'ave.c.withholding': 'Retención en origen',
  'ave.c.diff': 'Diferencia',
  'ave.c.status': 'Estado',
  'ave.c.bank': 'Banco',
  'ave.c.amelding': 'A-melding',
  'ave.c.run': 'Proceso',
  'ave.c.employeeCount': 'Número de empleados',
  'ave.c.openRun': 'Abrir proceso',
  'ave.c.none': 'Ninguno',
  'ave.c.seeRuns': 'Ver los procesos de nómina',
  'ave.c.requestDocs': 'Pedir documentación al cliente',
  'ave.c.close': 'Cerrar',
  'ave.c.alert': 'Aviso',
  'ave.c.assessment': 'Valoración',
  'ave.c.openCount': '{count} abiertos',
  'ave.c.ofCount': '{done} de {total}',
  'ave.c.yes': 'Sí',
  'ave.c.no': 'No',
  'ave.c.missing': 'Falta',
  'ave.c.settled': 'Cuadra',
  'ave.c.employee': 'Empleado',
  'ave.c.openAccount': 'Abrir cuenta',
  'ave.page.noAccount': 'El área de nómina no tiene ninguna cuenta de conciliación donde guardar la valoración.',
  'ave.page.theRun': 'el proceso',
  'ave.page.secOverview': 'Resumen',
  'ave.page.secRuns': 'Procesos de nómina',
  'ave.page.runsPosted': '{posted}/{total} contabilizados',
  'ave.page.ameldingMissing': '{count} faltan',
  'ave.page.secBank': 'Pagos bancarios',
  'ave.page.secTax': 'Impuestos y cotización del empleador',
  'ave.page.openTerms': '{count} plazos abiertos',
  'ave.page.settledUp': 'Liquidado',
  'ave.page.secHoliday': 'Paga de vacaciones y pensión',
  'ave.page.secLines': 'Líneas de nómina',
  'ave.page.secDocs': 'Documentación',
  'ave.page.secControls': 'Control y aprobación',
  'ave.page.areaFallback': 'Nómina',
  'ave.page.hintUnassessed': '{count} líneas de nómina requieren valoración',
  'ave.page.title': 'Nómina — sistema de nómina frente a libro mayor, A-melding y banco',
  'ave.page.responsible': 'Responsable: {name}',
  'ave.page.intro': 'La nómina se concilia con cuatro fuentes, no con un único saldo. La comparación es entre las cifras propias de los procesos de nómina y las cifras propias del libro mayor — la conciliación no vuelve a calcular el salario, la cotización del empleador ni la paga de vacaciones.',
  'ave.page.restricted': 'Los datos de nómina están restringidos. La conciliación muestra nombres de empleados e importes — no números de identificación personal ni números de cuenta bancaria. No los necesita para llegar a una conclusión.',
  'ave.page.txTitle': 'Control de empleados y líneas de nómina',
  'ave.page.resetFilters': 'Restablecer filtros',
  'ave.page.activeFilter': 'Filtro activo: {label}',
  'ave.page.lineCount': '{count} líneas de nómina',
  'ave.page.removeFilter': 'Quitar filtro',
  'ave.page.thEmployment': 'Relación laboral',
  'ave.page.thRun': 'Proceso de nómina',
  'ave.page.thChange': 'Cambio',
  'ave.page.assess': 'Valorar',
  'ave.page.viewAssessment': 'Ver valoración',
  'ave.page.noMatch': 'Ninguna línea de nómina coincide con los filtros.',
  'ave.page.noRuns': 'No hay procesos de nómina contabilizados en este periodo. Sin una base de nómina no se puede conciliar la nómina.',
  'ave.chk.derived.ameldingDiscrepancy': 'Las discrepancias de la A-melding están tratadas',
  'ave.chk.derived.missingPayments': 'Los pagos que faltan están investigados',
  'ave.chk.derived.duplicates': 'Los posibles pagos duplicados están valorados',
  'ave.chk.derived.negativeNet': 'El salario neto negativo está valorado',
  'ave.chk.derived.unusualChange': 'Los cambios salariales anómalos están valorados',
  'ave.chk.derived.benefits': 'Las retribuciones en especie están revisadas',
  'ave.chk.derived.leaver': 'El salario pagado a empleados que han dejado la empresa está explicado',
  'ave.chk.derived.taxCard': 'Los empleados sin tarjeta fiscal (skattekort) están atendidos',
  'ave.chk.autoTitle': 'Controles automáticos',
  'ave.chk.autoHint': 'Los controles no marcan nada en la lista de verificación profesional. Indican qué debería haber revisado quien marca los puntos.',
  'ave.chk.thCheck': 'Control',
  'ave.chk.thResult': 'Resultado',
  'ave.chk.ran': 'Ejecutado',
  'ave.chk.findings': '{count} hallazgos',
  'ave.chk.noFindings': 'Sin hallazgos',
  'ave.chk.listTitle': 'Lista de verificación profesional',
  'ave.chk.noPoints': 'No hay puntos de control definidos para la nómina en este periodo. La lista de verificación sigue las cuentas del área — añade una cuenta de nómina para obtener el programa de trabajo.',
  'ave.chk.readOnlySuffix': '(del preparador, solo lectura)',
  'ave.chk.scopeHint': 'Los puntos se aplican a toda el área de nómina. Una marca se guarda en todas las cuentas de nómina del periodo.',
  'ave.chk.groupItems': 'Partidas que requieren tratamiento',
  'ave.chk.handled': '{done} de {total} tratados',
  'ave.chk.notRelevant': 'No aplica en este periodo',
  'ave.chk.followsAssessments': 'Se deduce de las valoraciones',
  'ave.chk.groupAssessments': 'Valoraciones profesionales generales',
  'ave.chk.groupReady': 'Preparación para la revisión',
  'ave.chk.performedBy': 'Realizado por {name}',
  'ave.chk.progress': '{done} de {total} puntos de control completados',
  'ave.chk.blk.linesOne': '{count} línea de nómina requiere valoración',
  'ave.chk.blk.linesMany': '{count} líneas de nómina requieren valoración',
  'ave.chk.blk.mainOne': '{count} área de control no cuadra entre las fuentes',
  'ave.chk.blk.mainMany': '{count} áreas de control no cuadran entre las fuentes',
  'ave.chk.blk.accountsOne': '{count} cuenta de control no cuadra con la base',
  'ave.chk.blk.accountsMany': '{count} cuentas de control no cuadran con la base',
  'ave.chk.blk.amelding': '{count} procesos de nómina no están registrados como declarados',
  'ave.chk.blk.bankOne': '{count} proceso de nómina no está registrado como pagado',
  'ave.chk.blk.bankMany': '{count} procesos de nómina no están registrados como pagados',
  'ave.chk.blk.checklistOne': 'Queda {count} punto de control',
  'ave.chk.blk.checklistMany': 'Quedan {count} puntos de control',
  'ave.chk.conclTitle': 'Conclusión y aprobación',
  'ave.chk.conclLabel': 'Conclusión',
  'ave.chk.conclPlaceholder': '¿Qué muestra la revisión de la nómina de este periodo?',
  'ave.chk.conclSavedAs': 'Se guarda como justificación del punto de control «{label}».',
  'ave.chk.risk': 'Riesgo restante',
  'ave.chk.nothingLeft': 'No queda nada que impida enviar el área a revisión.',
  'ave.chk.followUp': 'Seguimiento en el próximo periodo',
  'ave.chk.noFollowUp': 'Ninguna valoración está marcada para seguimiento en el próximo periodo.',
  'ave.chk.followedUp': 'En seguimiento',
  'ave.chk.runGross': '{run} · {money} brutos',
  'ave.chk.measure': 'Medida: {measure}',
  'ave.chk.noMeasure': 'Sin medidas anotadas',
  'ave.chk.deadline': 'Plazo {date}',
  'ave.chk.openAssessment': 'Abrir valoración',
  'ave.chk.sendToReview': 'Enviar el área a revisión',
  'ave.chk.leftOne': 'Queda una cosa antes de poder enviar el área.',
  'ave.chk.leftMany': 'Quedan {count} cosas antes de poder enviar el área.',
});
